import { Create, DateInput, DateTimeInput, FormDataConsumer, SelectInput, SimpleForm, TextInput, required } from "react-admin";
import { RichTextInput } from 'ra-input-rich-text';
import {FileInput} from "../fileinputs/eventFileUpload";

export function PaintingCreate(props) {


    return (
        <Create>
            <SimpleForm>
                <TextInput source="title" validate={required()} />
                <RichTextInput source="description" />
                <FileInput source="images" add edit />
            </SimpleForm>

        </Create>
    );
}